export interface ProductType {
	Id: number | null;
	Name: string;
	Description: string;
	TPHGoal: number | null;
	Prefix: string;
	Active: boolean;
}

export const PRODUCT_TYPE_INITIAL_VALUES: ProductType = {
	Id: null,
	Name: "",
	Description: "",
	TPHGoal: null,
	Prefix: "",
	Active: true,
};
